import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './CardLinkGrid.module.scss';

interface CardLinkGridProps {
  classNames?: string | string[];
  children: ReactNode;
}

const CardLinkGrid = ({ classNames, children }: CardLinkGridProps) => (
  <ul className={cn(styles.gridContainer, classNames)}>{children}</ul>
);

export default CardLinkGrid;
